import React, { useState } from 'react';
import { Modal, Button, Input } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import styles from './PaperlessPush.styles.js';

export default function EditDeviceModal({ state, actions, translate }) {
  const [inputValue, setInputValue] = useState('');
  const [showError, setShowError] = useState(false);

  const handleSave = () => {
    if (!inputValue.trim()) {
      setShowError(true);
      return;
    }
    actions.onSaveEditDevice(inputValue);
    setShowError(false);
  };

  return (
    <Modal open={true} onCancel={() => actions.setShowDeviceModal(false)} footer={null}>
      <div style={styles.editIcon}>
        <EditOutlined style={{ fontSize: 24 }} />
      </div>

      <div style={styles.editTitle}>{translate('paperlessPush.editDeviceModal.editTitle')}</div>

      <div style={styles.editDescription}>
        {translate('paperlessPush.editDeviceModal.editDescription')}
      </div>

      <div style={styles.editDescription}>
        {translate('paperlessPush.editDeviceModal.editNote')}
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={{ fontWeight: 'bold' }}>
          {translate('paperlessPush.editDeviceModal.editInputName')}
        </label>
        <Input
          placeholder={!inputValue ? state.selectedDeviceUUID : undefined}
          value={inputValue}
          onChange={e => {
            setInputValue(e.target.value);
            setShowError(false);
          }}
        />
        {showError && (
          <p style={{ color: 'red', marginTop: 4 }}>
            {translate('paperlessPush.editDeviceModal.errors.emptyName')}
          </p>
        )}
      </div>

      <div>
        <Button key="save" type="primary" onClick={handleSave} style={styles.saveButtonContainer}>
          {translate('paperlessPush.editDeviceModal.saveButton')}
        </Button>
      </div>
    </Modal>
  );
}
